import { Flex, Grid } from '@chakra-ui/react';
import React from 'react';
import { RichText, SimpleCarousel } from 'shared';
import { CateringFormatModel } from 'entities';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { CateringFormatMainHeader } from './CateringFormatMainHeader';
import { CateringFormatMainMenusSection } from './CateringFormatMainMenusSection';

export type CateringFormatMainProps = {
    cateringFormat?: CateringFormatModel
}

export const CateringFormatMain: React.FC<CateringFormatMainProps> = ({
    cateringFormat,
}) => (
    <Flex
        flexDirection="column"
    >
        <Helmet>
            <title>{cateringFormat?.name}</title>
            <meta name="description" content={richTextToString(cateringFormat?.description)} />
            <meta property="og:title" content={cateringFormat?.name} />
        </Helmet>
        <CateringFormatMainHeader
            formatName={cateringFormat?.name || ''}
            padding="2rem 2rem 0 2rem"
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            background="white"
            width="100%"
            margin="0 auto"
        />
        <Grid
            templateColumns={{
                base: '1fr',
                lg: '2fr 3fr',
            }}
            gap="2rem"
            padding="2rem"
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            background="white"
            width="100%"
            margin="0 auto"
        >
            <Flex
                flexDirection="column"
            >
                <RichText
                    content={cateringFormat?.description || []}
                />
            </Flex>
            <SimpleCarousel
                aspectRatio="3 / 2"
                images={cateringFormat?.images?.map(({ url }) => url) || []}
            />
        </Grid>
        {cateringFormat?.menus && cateringFormat.menus.length > 0 ? (
            <Grid
                background="#000000"
            >
                <CateringFormatMainMenusSection
                    menus={cateringFormat?.menus || []}
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                />
            </Grid>
        ) : null}
    </Flex>
);
